import { styled } from 'styled-components';

export const DescriptionText = styled.p`
  color: rgba(0, 0, 0, 0.65);
  margin: 0;
`;
